import { Injectable } from '@angular/core';
import { TUserLoginSession } from '@app/shared/models/user-model';
import { LOCALSTORAGE_LOGIN_SESSION } from '@app/shared/utils/user-util';

@Injectable({
  providedIn: 'root',
})
export class LoginsessionService {
  constructor() {}

  storeLoginSession(sessionDetail: TUserLoginSession) {
    localStorage.setItem(
      LOCALSTORAGE_LOGIN_SESSION,
      JSON.stringify(sessionDetail),
    );
  }

  updateExtensionCount(count: number) {
    let sessionDetail = { ...this.getLoginSession() } as TUserLoginSession;
    sessionDetail.extensionCount = count;
    this.storeLoginSession(sessionDetail);
  }

  updateConfirmStatus(status: boolean) {
    let sessionDetail = { ...this.getLoginSession() } as TUserLoginSession;
    sessionDetail.isConfimToken = status;
    this.storeLoginSession(sessionDetail);
  }
  updateConfirmDate(status: string) {
    let sessionDetail = { ...this.getLoginSession() } as TUserLoginSession;
    sessionDetail.confirmDate = status;
    this.storeLoginSession(sessionDetail);
  }

  public getLoginSession() {
    const sessionDetail = JSON.parse(
      localStorage.getItem(LOCALSTORAGE_LOGIN_SESSION) as string,
    ) as TUserLoginSession;

    return sessionDetail;
  }

  getLoginTime() {
    const sessionDetail = this.getLoginSession();
    return new Date(sessionDetail?.loginTime);
  }

  getExtensionCount() {
    const sessionDetail = this.getLoginSession();
    return sessionDetail?.extensionCount;
  }

  getConfirmDate() {
    const sessionDetail = this.getLoginSession();
    return sessionDetail?.confirmDate;
  }

  getConfirmToken() {
    const sessionDetail = this.getLoginSession();
    return sessionDetail?.isConfimToken;
  }

  getLoginTimeHours() {
    const loginTimeMS = this.getLoginTimeMilliSeconds();
    const confirmHour = loginTimeMS / (1000 * 60 * 60);
    return confirmHour;
  }

  convertSecondsToMilliSeconds(seconds: number) {
    return seconds * 60 * 1000;
  }

  getLoginTimeSeconds() {
    const loginTimeMS = this.getLoginTimeMilliSeconds();
    return this.toCalculateSeconds(loginTimeMS);
  }

  getSecondsCompareToConfirm(date: Date) {
    const milliSeconds = this.getMilliSeconds(date);
    return this.toCalculateSeconds(milliSeconds);
  }

  private getLoginTimeMilliSeconds() {
    const sessionDetail = this.getLoginSession();
    return this.getMilliSeconds(new Date(sessionDetail?.loginTime));
  }

  private getMilliSeconds(sessionDate: Date) {
    let startDate = sessionDate;
    let endDate = new Date();

    let confirmMS = endDate.getTime() - startDate.getTime();

    return confirmMS;
  }

  private toCalculateSeconds(milliSeconds: number) {
    const confirmSeconds = milliSeconds / (1000 * 60);
    return confirmSeconds;
  }
}
